import { render, staticRenderFns } from "./create-training-program.component.vue?vue&type=template&id=bf9a6050&scoped=true&"
import script from "./create-training-program.component.vue?vue&type=script&lang=js&"
export * from "./create-training-program.component.vue?vue&type=script&lang=js&"
import style0 from "./create-training-program.component.vue?vue&type=style&index=0&id=bf9a6050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9a6050",
  null
  
)

export default component.exports